import Swiper from 'swiper';
import { Navigation, Manipulation, Pagination, Thumbs, FreeMode } from 'swiper/modules'
import { onVisibleCallback } from './helpers';

export function init() {
  qAll('.slider-type-1').forEach((el) => (el.control = new SliderType1(el)));
  qAll('.slider-type-2').forEach((el) => (el.control = new SliderType2(el)));
  qAll('.slider-type-3').forEach((el) => (el.control = new SliderType3(el)));
  qAll('.slider-history-and-vision').forEach(
    (el) => (el.control = new SliderHistoryAndVision(el))
  );
}

export class SliderType1 {
  constructor(el) {
    this.$wrapper = el;
    this.isWide = this.$wrapper.matches('[data-wide]');

    this.breakPoints = {
      650: {
        slidesPerView: 2,
      },
    };

    if (this.isWide) {
      this.breakPoints[1290] = {
        slidesPerView: 3,
      };
    }

    onVisibleCallback({
      element: this.$wrapper,
      once: true,
      callback: this.init.bind(this),
    });
  }

  init() {
    this.swiper = new Swiper(this.$wrapper.querySelector('.swiper'), {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      lazy: true,
      autoHeight: true,
      breakpoints: this.breakPoints,
      navigation: {
        enabled: 1,
        prevEl: this.$wrapper.querySelector('.prev'),
        nextEl: this.$wrapper.querySelector('.next'),
      },
    });
  }
}

export class SliderType2 {
  constructor(el) {
    this.$wrapper = el;

    onVisibleCallback({
      element: this.$wrapper,
      once: true,
      callback: this.init.bind(this),
    });
  }

  init() {
    this.swiper = new Swiper(this.$wrapper.querySelector('.swiper'), {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      lazy: true,
      autoHeight: true,
      navigation: {
        enabled: 1,
        prevEl: this.$wrapper.querySelector('.prev'),
        nextEl: this.$wrapper.querySelector('.next'),
      },
    });
  }
}

export class SliderType3 {
  constructor(el) {
    this.$wrapper = el;

    this.$wrapper.addEventListener('click', (event) => {
      if (event.target.matches('.thumbnails img'))
        this.swiper.slideTo(event.target.dataset.slide);
    });

    onVisibleCallback({
      element: this.$wrapper,
      once: true,
      callback: this.init.bind(this),
    });
  }

  init() {
    this.swiper_thumbnails = new Swiper(this.$wrapper.querySelector('.swiper-thumbnails'), {
      modules: [FreeMode],
      slidesPerView: 3,
      spaceBetween: 30,
      lazy: true,
      freeMode: true
    });

    this.swiper_main = new Swiper(this.$wrapper.querySelector('.swiper-main'), {
      modules: [Pagination, Manipulation, Navigation, Thumbs],
      slidesPerView: 1,
      spaceBetween: 30,
      lazy: true,
      pagination: {
        el: this.$wrapper.querySelector('.swiper-pagination'),
      },
      navigation: {
        enabled: 1,
        prevEl: this.$wrapper.querySelector('.prev'),
        nextEl: this.$wrapper.querySelector('.next'),
      },
      thumbs: {
        swiper: this.swiper_thumbnails
      }
    });
  }
}

export class SliderHistoryAndVision {
  constructor(el) {
    this.$wrapper = el;
    this.$timelineItems = this.$wrapper.querySelectorAll('.timeline-item');

    onVisibleCallback({
      element: this.$wrapper,
      once: true,
      callback: this.init.bind(this),
    });

    this.$wrapper.addEventListener('click', (event) => {
      if (event.target.matches('.timeline-item'))
        this.swiper.slideTo(event.target.dataset.slide);
    });
  }

  init() {
    this.swiper = new Swiper(this.$wrapper.querySelector('.swiper'), {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      lazy: true,
      autoHeight: true,
      on: {
        slideChange: () => this.setActiveTimeline(this.swiper.activeIndex),
      },
    });

    this.setActiveTimeline(this.swiper.activeIndex);
  }

  setActiveTimeline(index) {
    this.$timelineItems.forEach((item) =>
      item.classList.remove('timeline-item--active')
    );

    this.$timelineItems.forEach((item) => {
      if (item.dataset.slide == index)
        item.classList.add('timeline-item--active');
    });
  }
}
